class SortCollection extends HTMLElement {
  constructor() {
    super();
    this.CollectionFiltersForm = document.querySelector('collection-filters-form') || null;
    this.addEventListener('change', (event) => this.handleChange(event));
  }

  handleChange(event) {
    const value = event.target.value;
    // Set the right url sort_by parameter
    const url = new URL(window.location);
    let params = new URLSearchParams(url.search);
    params.delete('sort_by');
    // Update view param when not empty
    if (value != '') {
      params.set('sort_by', value);
      // Call method from class component and render the collection results
      this.CollectionFiltersForm?.renderPage(params.toString());
    }
  }
}

customElements.define('sort-collection', SortCollection);
